import { render } from "./KnPivotTableEditableField.vue?vue&type=template&id=2198c941&scoped=true&ts=true"
import script from "./KnPivotTableEditableField.vue?vue&type=script&lang=ts"
export * from "./KnPivotTableEditableField.vue?vue&type=script&lang=ts"

import "./KnPivotTableEditableField.vue?vue&type=style&index=0&id=2198c941&scoped=true&lang=css"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2198c941"]])

export default __exports__